<script>
	module.exports = {
		props: {
			columns: {
				type: Array
			},
			data: {
				required: true
			},
			onGridCellClick: {
				type: Function,
				default: function (record, col) {}
			},
			loadingMessage: {
				default: "Sit tight, your students' data is loading!"
			},
			noDataMessage: {
				default: 'No data is available. Please try a different selection.'
			}
		},
		methods: {
			getGridCellDisplayValue: function (record, col) {
				if (col.formatter) {
					return col.formatter.call(this, record[col.field], record, col);
				} else {
					return record[col.field];
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/flexbox';
	@import 'config/colors';

	.table.results-grid {
		width: auto;
		border-collapse: collapse;
		.thead .cell {
			text-align: center;
			text-transform: none;
			font-size: 1rem;
			font-weight: 600;
			border-width: 1px 0 0 0;

			&:not(:last-of-type) {
				border-right: 1px solid $c-grey;
			}
			.cell-wrapper {
				@include flexbox();
				align-items: center;
				justify-content: center;
			}
			&.left-text .cell-wrapper {
				justify-content: left;
			}
			&.right-text .cell-wrapper {
				justify-content: right;
			}
		}

		.tr {
			// display: table-row;
			@include flexbox();
		}

		.cell {
			@include flex(1);
			text-align: center; // display: table-cell;
			border-bottom: 1px solid $c-grey;
			vertical-align: middle;
			min-width: 0;
			font-size: 1rem;
			line-height: 1.25rem;

			&:not(:last-of-type) {
				border-right: 1px solid $c-grey;
			}
			&.left-text {
				text-align: left;
			}
			&.right-text {
				text-align: right;
			}
			.cell-wrapper {
				text-overflow: ellipsis;
				height: 100%;
				width: 100%;
				overflow: hidden; // white-space: nowrap;
				min-width: 0;
				padding: 0.5rem;

				&.loading {
					display: none;
				}

				&.link-wrapper {
					color: inherit;
					cursor: pointer;
					display: block;

					@media print {
						&::after {
							// hide href
							content: '';
						}
					}
				}

				.link-cell {
					cursor: pointer;
				}
			}
		}

		.tfoot {
			// display: table-footer-group;
			font-weight: bold;
		}
	}

	.requests-ongoing {
		.table.results-grid .cell .cell-wrapper {
			&.no-data {
				display: none;
			}
			&.loading {
				display: block;
			}
		}
	}
</style>
<template>
	<div class="table results results-grid">
		<slot name="thead">
			<div class="tr thead">
				<div
					class="cell"
					v-for="col in columns"
					:key="col.field"
					:style="{ flex: col.flex }"
					:class="[col.textAlign ? col.textAlign + '-text' : '']">
					<div
						class="cell-wrapper"
						v-html="col.text"></div>
				</div>
			</div>
		</slot>
		<div class="tbody">
			<slot name="tbody">
				<div
					class="tr"
					v-if="data && data.length"
					v-for="record in data"
					:key="record.assignmentId">
					<div
						class="cell"
						v-for="col in columns"
						:key="col.field"
						:class="[col.textAlign ? col.textAlign + '-text' : '']"
						:style="{ flex: col.flex }">
						<a
							v-if="getGridCellDisplayValue(record, col).includes('link-cell')"
							href="javascript:void(0)"
							class="cell-wrapper link-wrapper print-visible"
							@click="onGridCellClick(record, col)"
							v-html="getGridCellDisplayValue(record, col)">
						</a>
						<div
							v-else
							class="cell-wrapper"
							v-html="getGridCellDisplayValue(record, col)"></div>
					</div>
				</div>
			</slot>
			<slot name="loading-body">
				<div
					v-if="!data || !data.length"
					class="tr">
					<div
						class="cell center-text"
						style="flex: 1">
						<div class="cell-wrapper no-data">
							{{ noDataMessage }}
						</div>
						<div class="cell-wrapper loading">
							{{ loadingMessage }}
						</div>
					</div>
				</div>
			</slot>
		</div>
	</div>
</template>
